const baseIconContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "icon",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createIconEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseIconContent,
    data: {
      ...baseIconContent.data,
      key,
      value: "", // value remains empty as in the original
    },
    translation: {
      ...baseIconContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const iconEntries = [
  { title: "Gear", key: "gear" },
  { title: "Leaderboard", key: "group" },
  { title: "Filter", key: "filter" },
  { title: "Grey Coin", key: "greyCoin" },
  { title: "Blank Coin", key: "blankCoin" },
  { title: "Grey Heart", key: "greyHeart" },
  { title: "Cash Prize", key: "cashPrize" },
  { title: "Delete", key: "delete" },
  { title: "Close", key: "close" },
  { title: "Color Ring", key: "colorRing" },
  { title: "Play Game", key: "playGameIcon" },
  { title: "Play Icon", key: "playIcon" },
  { title: "Recently Played Games", key: "recentlyPlayed" },
  { title: "Cash Color Ring", key: "cashColorRing" },
  { title: "Green Restart Game", key: "greenRestartGame" },
  { title: "Share Icon", key: "shareIcon" },
  { title: "Private Icon", key: "privateIcon" },
  { title: "Survey Icon", key: "surveyIcon" },
  { title: "Similar Games Icon", key: "similarGamesIcon" },
  { title: "Contributors Icon", key: "contributorsIcon" },
  { title: "Grey Circular Check Button", key: "greyCircularCheckButton" }
];

const icons = iconEntries.map(({ title, key }) => createIconEntry(title, key));

export { icons };